import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useTheme } from 'app/shopify';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';

type HelpRole = 'borrower' | 'lender';

export function HelpRoleToggle({ role, onChange }: { role: HelpRole; onChange: (role: HelpRole) => void }) {
  const theme = useTheme();
  const { t } = useTranslation('help');

  return (
    <Row backgroundColor="surface.inverse.tertiary-neutral" borderRadius="radius.full" padding="spacing.general.x1">
      {(['borrower', 'lender'] as const).map((value) => {
        const selected = role === value;
        return (
          <Pressable
            key={value}
            onPress={() => onChange(value)}
            style={{
              flex: 1,
              alignItems: 'center',
              justifyContent: 'center',
              alignSelf: 'stretch',
              borderRadius: 999,
              paddingVertical: 10,
              paddingHorizontal: theme.spacing['spacing.general.x4'],
              backgroundColor: selected ? theme.colors['text.primary'] : 'transparent',
            }}
          >
            <Text
              color={selected ? 'text.inverse.primary' : 'text.primary'}
              fontWeight="700"
              fontSize={15}
              style={{ width: '100%' }}
              textAlign="center"
            >
              {t(value === 'borrower' ? 'roleBorrow' : 'roleLend')}
            </Text>
          </Pressable>
        );
      })}
    </Row>
  );
}
